import _styled from "styled-components";
const _excluded = ["style", "className", "children", "disableBorder"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import theme from '@adsk/alloy-react-theme';
const Header = _ref => {
  let {
      style,
      className,
      children,
      disableBorder
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, props, {
    className: className,
    $_css: [theme.typography.heading1, {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      color: theme.tokens.colors.text.primary.value,
      position: 'relative',
      minHeight: 70,
      borderBottom: !disableBorder ? "1px solid ".concat(theme.tokens.colors.border.subtle.value) : '',
      padding: "20px ".concat(theme.spacing.L, "px"),
      wordBreak: 'break-word'
    }, style]
  }), children);
};
Header.propTypes = {
  /** The content of modal */
  children: PropTypes.any,
  /** Styles applied to the root element */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /** Class applied to the root element */
  className: PropTypes.string,
  /** disable border bottom */
  disableBorder: PropTypes.bool
};
export default Header;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Header___StyledDiv",
  componentId: "sc-1ezxjle-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=Header.js.map